import {
  getAutoGradeStatus,
  mapAutoGradeStatusTooltip,
  getAutoGradeStatusFromContext,
  LIGHT_STATUS_COLOR_MAP
} from '@/helpers/smartIntegrations';
import ContentType from '@/helpers/contentType';

export default {
  name  : 'StatusChip',
  props : {
    topic: {
      type     : Object,
      required : true
    },
    context: {
      type     : Object,
      required : true
    }
  },
  data() {
    return {
      LIGHT_STATUS_COLOR_MAP,
      autoGradeStatusMap: mapAutoGradeStatusTooltip()
    };
  },
  computed: {
    autoGradeStatus() {
      return getAutoGradeStatusFromContext(this.context);
    },
    hasAutoGrade() {
      if (this.topic.topicTypeId !== ContentType.TASK) {
        return false;
      }

      return this.topic.hasAutoGrade;
    },
    autoGradeStatusTooltip() {
      const autoGradeResponse = this.topic.content?.autoGradeResponse;
      const autoGradeStatus = autoGradeResponse?.status;

      return getAutoGradeStatus({
        autoGradeResponse,
        autoGradeStatus,
        tooltipPropName       : 'tooltip',
        autoGradeStatusMap    : this.autoGradeStatusMap,
        getterAutoGradeStatus : this.autoGradeStatus
      });
    },
    statusChip() {
      if (this.hasAutoGrade) {
        return this.autoGradeStatusTooltip;
      }

      if (this.isAvaliaAndInactive) {
        return {
          tooltip : this.$t('contentType.avalia.textTooltipTopicAvaliaProcessing'),
          color   : 'var(--v-warning-base)',
          icon    : 'mdi-progress-clock'
        };
      }

      if (this.isWConferenceNotIntegrated) {
        return {
          tooltip : this.$t('contentType.scorm.textTooltipTopicError'),
          color   : 'var(--v-error-base)',
          icon    : 'mdi-alert'
        };
      }
    }
  }
};
